module.exports = __webpack_public_path__ + "media/images/placeholders/arbeitgeber-d048d1ad114abec4daafecf6f2c85005.jpg";